import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { FarmListResponse, FarmResponse, FarmRequest } from "../schemas";
import {
  createGranularRequestConfig,
  GranularCatalogConfig,
} from "@granular/fabric-catalog-helpers";

const GET = async (
  params: {
    limit?: number;
    offset?: number;
    default_farm?: boolean;
    show_empty_farms?: boolean;
  },
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<FarmListResponse>> => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value.toString());
  });
  const queryParams = searchParams.toString();
  const url = `/api/fields-svc/v2/farm${queryParams && "?" + queryParams}`;
  const response = await axios.get(
    url,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

const POST = async (
  farm: FarmRequest,
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<FarmResponse>> => {
  const response = await axios.post(
    "/api/fields-svc/v2/farm",
    farm,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  GET,
  POST,
};
